import React, { useRef, useState, useEffect } from 'react';
import styles from './s.module.less';

interface ExpandableTextProps {
    content: string;
    line?: number;
    moreText?: string;
    lessText?: string;
    customClass?: string;
    isRichText?: boolean;
}

const ExpandableText: React.FC<ExpandableTextProps> = ({
    content,
    line = 2,
    moreText = 'View all',
    lessText = 'View less',
    customClass = '',
    isRichText = false,
}) => {
    const textRef = useRef<HTMLDivElement>(null);
    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (el && !expanded) {
            const isOverflowing = el.scrollHeight > el.clientHeight;
            setShowToggle(isOverflowing);
        }
    }, [content, expanded]);

    return (
        <div className={`${styles.expandableTextWrap} ${customClass}`}>
            {isRichText ? (
                <div
                    ref={textRef}
                    className={styles.text}
                    style={expanded ? {} : {
                        display: '-webkit-box',
                        WebkitLineClamp: line,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {content}
                </div>) : (
                <div
                    ref={textRef}
                    className={styles.text}
                    style={expanded ? {} : {
                        display: '-webkit-box',
                        WebkitLineClamp: line,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            )}
            {showToggle && (
                <span
                    className={styles.toggle}
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? lessText : moreText}
                </span>
            )}
        </div>
    );
};

export default ExpandableText;
